import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-lg leading-[1.2] font-medium" }
const _hoisted_3 = { class: "text-muted-foreground text-[10px] leading-none" }

import type { DashboardStatItem } from '@/types';
    import Icon from '@/components/Icon.vue';
    import { Link } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardStatItem',
  props: {
    stat: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.stat.href ? _unref(Link) : 'div'), {
    key: _ctx.stat.description,
    class: "flex w-full shrink-0 items-center gap-2 md:max-w-[200px] 2xl:shrink",
    href: _ctx.stat.href
  }, {
    default: _withCtx(() => [
      _createVNode(Icon, {
        name: _ctx.stat.icon,
        class: "text-destructive size-6 shrink-0"
      }, null, 8, ["name"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.stat.value), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.stat.description), 1)
      ])
    ]),
    _: 1
  }, 8, ["href"]))
}
}

})